import React from 'react';

const SmartPhone = ({ color = 'var(--actionMinor-500)', ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
        <path fill="#fff" d="M0 .5h24v24H0z" />
        <path
            fill={color}
            fillRule="evenodd"
            d="M15.5 2.5h-8C6.12 2.5 5 3.518 5 4.773v15.454C5 21.482 6.12 22.5 7.5 22.5h8c1.38 0 2.5-1.018 2.5-2.273V4.773C18 3.518 16.88 2.5 15.5 2.5zm-4.275 18.864c-.678 0-1.225-.497-1.225-1.113s.547-1.113 1.225-1.113c.677 0 1.224.497 1.224 1.113s-.547 1.113-1.224 1.113zM16 17.954H7V5.228h9v12.728z"
            clipRule="evenodd"
        />
    </svg>
);

export default SmartPhone;
